module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-1"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('v-form', {
    ref: "organizationEditForm",
    model: {
      value: (_vm.validated),
      callback: function($$v) {
        _vm.validated = $$v
      },
      expression: "validated"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.organization'),
      "required": "",
      "rules": [function (v) { return !!v || _vm.$t('account.vali-org-name'); }]
    },
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.description')
    },
    model: {
      value: (_vm.edit.description),
      callback: function($$v) {
        _vm.$set(_vm.edit, "description", $$v)
      },
      expression: "edit.description"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.incharge')
    },
    model: {
      value: (_vm.edit.contact),
      callback: function($$v) {
        _vm.$set(_vm.edit, "contact", $$v)
      },
      expression: "edit.contact"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('account.tel'),
      "rules": _vm.phoneRules
    },
    model: {
      value: (_vm.edit.phone),
      callback: function($$v) {
        _vm.$set(_vm.edit, "phone", $$v)
      },
      expression: "edit.phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('user-params.email'),
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.edit.email),
      callback: function($$v) {
        _vm.$set(_vm.edit, "email", $$v)
      },
      expression: "edit.email"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('aplix-use-only.customer-category'),
      "items": _vm.customerCategories,
      "item-text": "name",
      "item-value": "customerCategoryId",
      "rules": [function (v) { return !!v || _vm.$t('validate.select'); }],
      "required": "",
      "auto": ""
    },
    model: {
      value: (_vm.edit.customerCategoryId),
      callback: function($$v) {
        _vm.$set(_vm.edit, "customerCategoryId", $$v)
      },
      expression: "edit.customerCategoryId"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("organizations.limit-settings")))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": _vm.$t('organizations.no-limit')
    },
    model: {
      value: (_vm.edit.createNoLimit),
      callback: function($$v) {
        _vm.$set(_vm.edit, "createNoLimit", $$v)
      },
      expression: "edit.createNoLimit"
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('account.cancel')) + "\n            ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-4",
    attrs: {
      "color": "primary",
      "disabled": !_vm.validated
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateOrganization($event)
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('btn.save')) + "\n            ")])], 1), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "red--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-ccaba08c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationEdit.vue
// module id = 1949
// module chunks = 0